import { createSelector } from 'reselect'

import selectTrelloBoardsById from './selectTrelloBoardsById'

export default createSelector(selectTrelloBoardsById, boards => {
  if (!boards) return null
  return Object.values(boards)
})
